export default __webpack_public_path__ + "static/media/helm.56c044b6.png";